export var buildImageSrcSet = function buildImageSrcSet(imageSrcSet) {
  var sortedImages = imageSrcSet.sort(function (a, b) {
    return b.width - a.width;
  });
  var srcSet = sortedImages.map(function (_ref) {
    var src = _ref.src,
      unit = _ref.unit,
      width = _ref.width;
    return "".concat(src, " ").concat(width).concat(unit);
  }).join(', ');
  return srcSet;
};